interface Props {
  label: string;
}

export default function SectionLabel(props: Props) {
  const { label } = props;
  return (
    <div className="text-9px text-promGray font-spaceMono bg-promGray3 w-full pl-2">{label}</div>
  );
}
